<template lang="pug">
  v-card(max-width="500" )
    v-toolbar( 
      color="#3200E6"
      dark 
    )
      v-toolbar-title Drafts
      v-spacer
      v-btn(icon)
        v-icon mdi-close      
    v-list
      v-subheader Orders
      v-list-item(
        v-for="(order, i) in orders"
        :key="i"
      )
        v-list-item-content
          v-list-item-title {{order.title}}
          v-list-item-subtitle {{order.description}}
        v-btn(icon)
          v-icon(color="#3200E6") mdi-pencil
        v-btn(icon)
          v-icon(color="#E3476C") mdi-delete

      v-divider
      
      v-subheader Shipments
      v-list-item(
        v-for="(shipment, i) in shipments"
        :key="i"
      )
        v-list-item-content
          v-list-item-title {{shipment.title}}
          v-list-item-subtitle {{shipment.description}}

</template>
<script>
export default {
  name:'DraftList',
  props:{
    drafts:{
      type:Array
    }
  },
  data () {
    return {
      orders:[
        {
          title:'order1',
          description:'description1'
        },
        {
          title:'order2',
          description:'description2'
        },
        {
          title:'order3',
          description:'description3'
        }
      ],
      shipments:[]
    }
  },
  computed:{},
  methods:{},
  created(){}
}
</script>  

              
            
        
        
      
    